export default __webpack_public_path__ + "static/CarolineH-c67814d773f4b435e9497c4d9ad946bb.png";